am4core.addLicense('MP226372839');
am4core.useTheme(am4themes_animated);

// Create map instance
var chart = am4core.create('chartdiv', am4maps.MapChart);
chart.logo.disabled = true;

// Set map definition
chart.geodata = am4geodata_usaLow;

// Set projection
chart.projection = new am4maps.projections.AlbersUsa();
chart.seriesContainer.draggable = false;
chart.seriesContainer.resizable = false;
chart.maxZoomLevel = 1;

// Create map polygon series
var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

// Make map load polygon (like country names) data from GeoJSON
polygonSeries.useGeodata = true;
polygonSeries.mapPolygons.template.nonScalingStroke = true;

// Configure series
var polygonTemplate = polygonSeries.mapPolygons.template;
polygonTemplate.applyOnClones = true;
polygonTemplate.togglable = true;
polygonTemplate.tooltipText = '{name}';
polygonTemplate.nonScalingStroke = true;
polygonTemplate.strokeOpacity = 1;
polygonTemplate.fill = '#000';
var lastSelected;

polygonTemplate.events.on('hit', function(ev) {
  if (lastSelected) {
    // This line serves multiple purposes:
    // 1. Clicking a country twice actually de-activates, the line below
    //    de-activates it in advance, so the toggle then re-activates, making it
    //    appear as if it was never de-activated to begin with.
    // 2. Previously activated countries should be de-activated.
    lastSelected.isActive = false;
  }

  if (lastSelected !== ev.target) {
    lastSelected = ev.target;
  }

  setTimeout(function() {
    $('.info-name h2').text(ev.target.dataItem.dataContext.name + '_(' + ev.target.dataItem.dataContext.id + ')');
  }, 1300);
});

// Create hover state and set alternative fill color
var ss = polygonTemplate.states.create('active');
ss.properties.fill = am4core.color('#15253e');

var hs = polygonTemplate.states.create('hover');
hs.properties.fill = am4core.color('#15253e');


//circle progress
$('.info-gender__progress span span').each(function(index, elem) {
  let val = $(elem).attr('data-num');
  $(elem).text(val);
  $(elem).closest('.info-gender__progress').find('.progress-circle__stroke:nth-child(2)').css({'stroke-dashoffset': 'calc(' + 314.1592 * (val / 100) + '%)'});
});


function clocksAnimation() {
  $('.timezone__block--secondary .temperature-block h3 span').animate({ width: 'toggle' }, 400);
  setTimeout(function() {
    $('.timezone__block--secondary .temperature-block h3 span').animate({ width: 'toggle' }, 400);
  }, 500);

  $('.timezone__block--secondary .temperature-block__value span').text('0');

  $('.timezone__block--secondary .temperature-block__value span').each(function(index, elem) {
    counter(elem, 900, 1);
  });
}


function stateAnimation() {
  $('.info__block').animate({width: '0%'}, 150);
  $('.info__block').removeClass('hidden');
  $('.city').animate({width:'toggle'},600);
  setTimeout(function() {
    $('.info__block').addClass('hidden');
  }, 1000);

  name();
  city();
  car();
  setTimeout(function() {
    age();
  }, 300);
  
  gender();
}


function name() {
  setTimeout(function() {
    $('.info-name').animate({width: '100%'}, 250);
  }, 900);
}


function city() {
  setTimeout(function() {
    $('.info-city').css({'width': '100%'});
    setTimeout(function() {
      $('.city-1').animate({width:'toggle'},400);
    }, 200);
    setTimeout(function() {
      $('.city-2').animate({width:'toggle'},400);
    }, 400);
    setTimeout(function() {
      $('.city-3').animate({width:'toggle'},400);
    }, 600);
  }, 1100);
}


function car() {
  $('.info-car__table__chart span').text('0');
  setTimeout(function() {
    $('.info-car__table__arrow').css({'height': 0});
  }, 100);
  setTimeout(function() {
    $('.info-car').css({'width': '100%'});
  }, 1600);

  setTimeout(function() {
    counter('.info-car__table__chart span', 900);
    counter('.info-car__years li b b', 900);

    //arrow
    let max = $('.info-car__table__chart--1 span').attr('data-num');
    let car2 = $('.info-car__table__chart--2 span').attr('data-num') * 90 / max;
    let car3 = $('.info-car__table__chart--3 span').attr('data-num') * 90 / max;
    let car4 = $('.info-car__table__chart--4 span').attr('data-num') * 90 / max;
    let car5 = $('.info-car__table__chart--5 span').attr('data-num') * 90 / max;

    //result
    $('.info-car__table__chart--1 .info-car__table__arrow').css({'height': 90});
    $('.info-car__table__chart--2 .info-car__table__arrow').css({'height': car2});
    $('.info-car__table__chart--3 .info-car__table__arrow').css({'height': car3});
    $('.info-car__table__chart--4 .info-car__table__arrow').css({'height': car4});
    $('.info-car__table__chart--5 .info-car__table__arrow').css({'height': car5});
  }, 1800);
}


function age() {
  setTimeout(function() {
    $('.info-age').css({'width': '100%'});
    $('.info__block__content .info-age__decor').html('');

    let ages = [Number($('.age-anim-1 b b').text()), Number($('.age-anim-2 b b').text()), Number($('.age-anim-3 b b').text()),
      Number($('.age-anim-4 b b').text()), Number($('.age-anim-5 b b').text()), Number($('.age-anim-6 b b').text())];
    let percentsSum = ages.reduce(function(a, b) {
      return a + b;
    });
    if (percentsSum === 0) {
      percentsSum = 1;
    }

    ages.forEach(function(item, index, array) {
      let $ageFather = $('li.age-anim-' + (index + 1));
      if (item === 0) {
        $ageFather.hide();
      } else {
        $ageFather.show();
        let $decor = $ageFather.find('.info-age__decor');

        let fixedPercent = item / percentsSum * 100;

        if (fixedPercent <= 8)
          fixedPercent = 8;

        var i = 0;
        while (i < Math.ceil(0.26 * fixedPercent)) {
          $decor.append('<span> </span>');
          i++;
        }
      }
    });
  }, 2000);
}


function gender() {
  setTimeout(function() {
    $('.info-gender').css({'width': '100%'});
    counter('.info__block__row span span', 900);
    counter('.info__block__row b b', 1100);
    counter('.info-gender__progress span span', 1100);
  }, 2700);

  $('.gender-1').html('');
  $('.gender-2').html('');

  let male = $('.info__block__male').attr('data-num');
  let famale = $('.info__block__famale').attr('data-num');
  if(famale > male) {
    var i1 = 0;
    while (i1 < Math.floor(0.2 * +male)) {
      $('.gender-1').append('<li> </li>');
      i1++;
    }

    var i2 = 0;
    while (i2 < Math.ceil(0.2 * +famale)) {
      $('.gender-2').append('<li> </li>');
      i2++;
    }
  } else {
    var i1 = 0;
    while (i1 < Math.ceil(0.2 * +male)) {
      $('.gender-1').append('<li> </li>');
      i1++;
    }

    var i2 = 0;
    while (i2 < Math.floor(0.2 * +famale)) {
      $('.gender-2').append('<li> </li>');
      i2++;
    }
  }
}


function counter(selector, time2, step2, initValueByDataNum) {
  $(selector).each(function(index, elem) {
    var currentValue = initValueByDataNum === true ? Number($(elem).attr('data-previous-num')) : 0;

    $({ Counter: currentValue }).animate({
      Counter: $(elem).attr('data-num')
    }, {
      duration: time2,
      easing: 'swing',
      step: function() {
        var currentStep = step2 !== 1 ? Math.round(this.Counter * 10) / 10 : Math.ceil(this.Counter);

        if (selector === '.info-gender__progress span span') {
          var currentStep = step2 !== 1 ? Math.round(this.Counter * 10) / 10 : Math.ceil(this.Counter);
          $(elem).closest('.info-gender__progress').find('.progress-circle__stroke:nth-child(2)').css({ 'stroke-dashoffset': 'calc(' + 314.1592 * (this.Counter / 100) + '%)' });
        }

        $(elem).text(currentStep.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        $(elem).attr('data-previous-num', currentStep);
      },
      complete: function() {
        var finalNumber = Number($(elem).attr('data-num'));
        $(elem).text(finalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      }
    });
  });
}


function getIdForPoint(lat, lon) {
  return 'map-point_' + lat.toString().replace('.', '_') + '_' + lon.toString().replace('.', '_');
}


var IMAGE_MIN = 10;
var IMAGE_MAX = 20;
function getMinSize(allPositions) {
  return Math.min.apply(Math, allPositions.map(function(o) { return o.Size; }));
}
function getMaxSize(allPositions) {
  return Math.max.apply(Math, allPositions.map(function(o) { return o.Size; }));
}
function getPointScale(positionSize, positionsMin, positionsMax) {
  return ((IMAGE_MAX - IMAGE_MIN) * (positionSize - positionsMin)) / (positionsMax - positionsMin) + IMAGE_MIN;
}


function pulse(x, y, size) {
  var $pulseObj = $('<div class="pulse" style="position:absolute;left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px"></div>');
  $('#chartdiv').append($pulseObj);
  setTimeout(function() {
    $pulseObj.remove();
  }, 4000);
}


function drawPoint(currentId, x, y, size) {
  setTimeout(function() {
    //console.log('point ' + currentId + ' created');
    $('#chartdiv').append('<img class="point-marker" id="' + currentId + '" src="img/6.png" style="position:absolute;left:' + x + 'px; top:' + y + 'px; width:' + size + 'px; ' +
                          ' animation: twinkle ' + ((Math.random() * 2) + 10) + 's linear ' + ((Math.random() * 8) + 5) + 's infinite;" />');
    pulse(x, y, size);
  }, Math.floor(Math.random() * RELOAD_MAP_MS));
}


function resizePoint(currentId, oldSize, newSize, x, y, pixelSize) {
  setTimeout(function() {
    //console.log('point ' + currentId + ' size changed from ' + oldSize + ' to ' + newSize);
    $('#' + currentId).css('left', x + 'px').css('top', y + 'px').css('width', pixelSize + 'px');
    pulse(x, y, pixelSize);
  }, Math.floor(Math.random() * RELOAD_MAP_MS));
}


function deletePoint(currentId) {
  setTimeout(function() {
    var $elementToDelete = $('#' + currentId);
    if ($elementToDelete.length) {
      $elementToDelete.remove();
      points.delete(currentId);
      //console.log('point #' + currentId + ' deleted');
    } else {
      //console.error('point #' + currentId + ' could not be found and therefore was not deleted');
    }
  }, Math.floor(Math.random() * RELOAD_MAP_MS));
}


var RELOAD_MAP_MS = 40000;
let points = new Map();
function loadMap() {
  $.getJSON('jsons/main.json').done(function(data) {

    // Top counter
    $('.map__counter span').attr('data-num', data.Total);
    counter('.map__counter span', RELOAD_MAP_MS - 1, 1, true);

    if (data.MapPositions) {
      //console.log('Read map data');
      var maxSize = getMaxSize(data.MapPositions);
      var minSize = getMinSize(data.MapPositions);

      var pointsToDelete = Array.from(points.keys());

      for (let i in data.MapPositions) {
        var currentId = getIdForPoint(data.MapPositions[i].Latitude, data.MapPositions[i].Longitude);

        var indexInDeleteArray = pointsToDelete.indexOf(currentId);
        if (indexInDeleteArray > -1) {
          pointsToDelete.splice(indexInDeleteArray, 1);
        }

        if (!points.has(currentId)) {
          var size = getPointScale(data.MapPositions[i].Size, minSize, maxSize);
          var pos = chart.geoPointToSVG({ longitude: data.MapPositions[i].Longitude, latitude: data.MapPositions[i].Latitude });
          
          if (typeof(pos) == 'undefined')
            continue;
          
          var x = pos.x - (size / 2);
          var y = pos.y - (size / 2);
          points.set(currentId, data.MapPositions[i]);
          drawPoint(currentId, x, y, size);
        } else {
          var currPoint = points.get(currentId);
          if (Math.abs(currPoint.Size - data.MapPositions[i].Size) > 25) {
            var size = getPointScale(data.MapPositions[i].Size, minSize, maxSize);
            var pos = chart.geoPointToSVG({ longitude: data.MapPositions[i].Longitude, latitude: data.MapPositions[i].Latitude });
            
            if (typeof(pos) == 'undefined')
              continue;
            
            var x = pos.x - (size / 2);
            var y = pos.y - (size / 2);
            points.set(currentId, data.MapPositions[i]);
            resizePoint(currentId, currPoint.Size, data.MapPositions[i].Size, x, y, size);
          }
        }
      }

      pointsToDelete.forEach(keyToDelete => deletePoint(keyToDelete));
    }

    setTimeout(function() {
      loadMap();
    }, RELOAD_MAP_MS);
  }).fail(function() {
    console.log('Error loading map json, will retry soon');

    setTimeout(function() {
      loadMap();
    }, 15000);
  });
}


function loadClocks(i) {
  $.getJSON('jsons/clocks' + i + '.json').done(function(data) {

    let usTimezones = data.UsTimezones;
    $(usTimezones).each(function(index, element) {
      let DataElem = element;
      $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block__value li:first-child span').attr('data-num', DataElem.Temperature.Celsius);
      $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block__value li:last-child span').attr('data-num', DataElem.Temperature.Fahrenheit);
    });

    clocksAnimation();
    setTimeout(function() {
      // Israel
      let israelTimezone = data.IsraelTimezone;
      $('.timezone__block--primary .time-block span').text(israelTimezone.Abbreviation);
      $('.timezone__block--primary .time-block p').text(israelTimezone.Time);
      $('.timezone__block--primary .temperature-block h3 span').text(israelTimezone.City);
      $('.timezone__block--primary .temperature-block__value li:first-child span').text(israelTimezone.Temperature.Celsius);
      $('.timezone__block--primary .temperature-block__value li:last-child span').text(israelTimezone.Temperature.Fahrenheit);
      $('.timezone__block--primary .temperature-block__value p').text(israelTimezone.Temperature.WeatherDescription);
      $('.timezone__block--primary .timezone-btn').text(israelTimezone.Date);

      // US_Timezones
      $(usTimezones).each(function(index, element) {
        let DataElem = element;
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.time-block span').text(DataElem.Abbreviation);
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.time-block p').text(DataElem.Time);
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block h3 span').text(DataElem.City);
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block__value li:first-child span').text(DataElem.Temperature.Celsius);
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block__value li:last-child span').text(DataElem.Temperature.Fahrenheit);
        $('.timezone__block--secondary .timezone__block__row').eq(index).find('.temperature-block__value p').text(DataElem.Temperature.WeatherDescription);
      });

      setTimeout(function() {
        loadClocks(nextClockIndex(i));
      }, 15000);
    }, 180);
  }).fail(function() {
    console.log('Error loading clocks json, will retry soon');

    setTimeout(function() {
      loadClocks(nextClockIndex(i));
    }, 10000);
  });
}


function loadState(i) {
  $.getJSON('jsons/state' + i + '.json').done(function(data) {
    polygonSeries.data = [{
      'id': 'US-' + data.Code,
      'fill': am4core.color('#2F558E')
    }];
    polygonTemplate.propertyFields.fill = 'fill';

    let car = data.TopMakes;
    $(car).each(function(index, el) {
      $('.info-car__table__column').eq(index).find('span').attr('data-num', el.Value);
    });

    let years = data.TopVehiclesYears;
    $(years).each(function(index, el) {
      $('.info-car__years li').eq(index).find('b b').attr('data-num', el.Value);
    });

    let gender = data.Genders;
    $(gender).each(function(index, el) {
      $('.info-gender__block .info__block__row div').eq(index).find('.info__block__num').attr('data-num', el.Value).attr('data-num2', el.Value);
    });

    $('.info-gender__progress-1 span span').attr('data-num', data.Homeowners);
    $('.info-gender__progress-2 span span').attr('data-num', data.Married);

    stateAnimation();

    setTimeout(function() {
      //map
      $('.info__block__content h2').text(data.Name + '_(' + data.Code + ')');
      $('.info__block__city li .city-1').text(data.MostPopularCity);
      $('.info__block__city li .city-2').text(data.MostPopularName);
      $('.info__block__city li .city-3').text(data.MostPopularCarrier);
      $('.info__block__map-img img').attr('src', 'img/states_symbols/' + data.Name.toLowerCase().replace('_','-') +'.svg');

      //car
      $(car).each(function(index, el) {
        $('.info-car__table__column').eq(index).find('b').text(el.Make);
        $('.info-car__table__column').eq(index).find('img').attr('src', 'img/makes/' + el.Make +'.png');
      });

      //years
      let years = data.TopVehiclesYears;
      $(years).each(function(index, el) {
        $('.info-car__years li').eq(index).find('span').text(el.Year);
      });

      //popular model
      $('.info-car__popular span').text(data.MostPopularModel.Model);
      $('.info-car__popular img.img').attr('src', 'img/makes/' + data.MostPopularModel.Make + '.png');

      //age
      let age = data.AgeGroups;
      $(age).each(function(index, el) {
        $('.info-age li').eq(index).find('p').text(el.Range);
        $('.info-age li').eq(index).find('b b').text(el.Value);
      });

      //gender
      $(gender).each(function(index, el) {
        $('.info-gender__block .info__block__row div').eq(index).find('p').text(el.Gender);
      });

      setTimeout(function() {
        loadState(nextStateIndex(i));
      }, 13000);
    }, 450);
  })
    .fail(function() {
      loadState(nextStateIndex(i));
    });
}


function nextStateIndex(i) {
  if (i < 55) {
    return i + 1;
  } else {
    return 1;
  }
}


function nextClockIndex(i) {
  if (i < 3) {
    return i + 1;
  } else {
    return 0;
  }
}


loadClocks(0);
loadMap();
loadState(1);
